import { TClaim } from "../model/types";

export const formatAnalyzedDate = (claims: TClaim[]): string => {
  if (claims.length === 0) return "-";

  const dates = claims.map((claim) => claim.createdAt).filter(Boolean) as Date[];

  if (dates.length === 0) return "-";

  const date = new Date(Math.max(...dates.map((date) => date.getTime())));

  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric"
  });
};
